import React from 'react';
import { Modal, Progress } from 'antd';
import { CloudUploadOutlined } from '@ant-design/icons';
import '../../Assets/Css/Loader.css';

interface AnalyzingModalProps {
  open: boolean;
  uploadProgress?: number;
}

// Brand color from project
const BRAND_COLOR = '#8cc63f';

export const AnalyzingModal: React.FC<AnalyzingModalProps> = ({
  open,
  uploadProgress = 0,
}) => {
  return (
    <Modal
      open={open}
      closable={false}
      footer={null}
      centered
      width={600}
      maskClosable={false}
      destroyOnClose
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '40px 20px',
        }}
      >
        {/* Loader spinner matching project's Loader component */}
        <div
          style={{
            width: 60,
            height: 60,
            background: `linear-gradient(269.36deg, ${BRAND_COLOR} -23.62%, #fff 120.63%)`,
            marginBottom: 20,
            animation: 'rotate-plane 1.5s infinite ease-in-out',
          }}
        />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            fontSize: 18,
            color: BRAND_COLOR,
            fontWeight: 'bold',
            marginBottom: 16,
          }}
        >
          <CloudUploadOutlined style={{ fontSize: 24 }} />
          <span>Uploading file...</span>
        </div>
        <Progress
          percent={Math.floor(uploadProgress)}
          status="active"
          strokeColor={BRAND_COLOR}
          style={{ width: '80%', marginBottom: 16 }}
        />
        <p style={{ color: '#666', textAlign: 'center' }}>
          Please wait while your file is being uploaded.
        </p>
      </div>
    </Modal>
  );
};

export default AnalyzingModal;
